import React, { useCallback } from "react";

import Dropdown from "antd/es/dropdown";
import { SubMenuType } from "antd/es/menu/hooks/useItems";

import RoundButton from "../RoundButton";

const SubMenuActionButton: React.FC<{ action: SubMenuType; invisible?: boolean }> = ({
  action,
  invisible,
  ...props
}) => {
  const getParentElement = useCallback((trigger: HTMLElement) => trigger.parentElement!, []);

  return (
    <div tabIndex={invisible ? -1 : undefined} {...props}>
      <Dropdown
        disabled={action.disabled}
        getPopupContainer={getParentElement}
        menu={{ items: action.children }}
      >
        <RoundButton hasMenu leftIcon={action.icon} tabIndex={invisible ? -1 : undefined}>
          {action.label}
        </RoundButton>
      </Dropdown>
    </div>
  );
};

export default SubMenuActionButton;
